fccd-open-hours {
  .location-closed {
    font-weight: bold;
  }

  .location-tempclosed {
    font-weight: bold;
    color: red;
  }

  .no-margin-top-bottom {
    margin-top: 0px;
    margin-bottom: 0px;
  }

  .location-open {
    color: green;
    font-weight: bold;
  }
}
